import { render, staticRenderFns } from "./DocumentInfo.vue?vue&type=template&id=44c64007&scoped=true"
import script from "./DocumentInfo.vue?vue&type=script&lang=js"
export * from "./DocumentInfo.vue?vue&type=script&lang=js"
import style0 from "./DocumentInfo.vue?vue&type=style&index=0&id=44c64007&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "44c64007",
  null
  
)

export default component.exports